import React from "react";
import { Paper, Box, Typography, Grid, Stack, Chip } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BusinessIcon from "@mui/icons-material/Business";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import PersonIcon from "@mui/icons-material/Person";
import SecurityIcon from "@mui/icons-material/Security";
import { capitalizeFirstLetter } from "../../../utils/hooks/dataHandler";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

const ProfileInfo = ({ user }) => {
  const {
    uid,
    name,
    email,
    phoneCode,
    phoneNumber,
    status,
    user_type,
    user_role,
    address,
    created_by,
  } = user;

  const InfoField = ({ icon, label, value, color = "primary" }) => (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 2,
        p: 2,
        borderRadius: 2,
        bgcolor: "background.paper",
        border: "1px solid",
        borderColor: "divider",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          borderColor: `${color}.main`,
          boxShadow: 1,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 40,
          height: 40,
          borderRadius: "50%",
          bgcolor: `${color}.lighter`,
          color: `${color}.main`,
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          variant='caption'
          color='text.secondary'
          sx={{
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: 0.5,
          }}
        >
          {label}
        </Typography>
        <Typography
          variant='body1'
          sx={{
            fontWeight: 500,
            mt: 0.5,
            wordBreak: "break-word",
          }}
        >
          {value || "—"}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 3, sm: 4 },
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
    >
      <Typography
        variant='h6'
        sx={{
          fontWeight: 600,
          mb: 3,
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <SecurityIcon color='primary' />
        Account Information
      </Typography>

      <Grid container spacing={3}>
        {/* Basic Information */}
        <Grid item xs={12} md={6}>
          <Stack spacing={2}>
            <InfoField
              icon={<EmailIcon />}
              label='Email Address'
              value={email}
              color='primary'
            />
            <InfoField
              icon={<PhoneIcon />}
              label='Phone Number'
              value={`${phoneCode || ""}${phoneNumber}`}
              color='success'
            />
            <InfoField
              icon={<LocationOnIcon />}
              label='Address'
              value={address === "-" ? "Not provided" : "Provided"}
              color='info'
            />
          </Stack>
        </Grid>

        {/* Account Details */}
        <Grid item xs={12} md={6}>
          <Stack spacing={2}>
            <InfoField
              icon={<BusinessIcon />}
              label='Organization Name'
              value={user.subscription?.organization?.name || ""}
              color='primary'
            />
            <InfoField
              icon={<AccountBalanceIcon />}
              label='Organization GST Reg. No'
              value={user.subscription?.organization?.GST_registration_no || ""}
              color='warning'
            />
            <InfoField
              icon={<AdminPanelSettingsIcon />}
              label='Created By'
              value={capitalizeFirstLetter(
                created_by === "system" ? "Registration" : "admin",
              )}
              color='secondary'
            />
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ProfileInfo;
